import axios from "axios";

export const api = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`, withCredentials: true });

localStorage.removeItem("vq_token");

let refreshing = null;
api.interceptors.response.use(undefined, async (err) => {
  const cfg = err.config || {};
  const skip = ["/auth/refresh", "/auth/login", "/auth/register", "/auth/google"].some((p) => cfg.url?.includes(p));
  if (err.response?.status !== 401 || cfg._retried || skip) throw err;
  cfg._retried = true;
  refreshing = refreshing || api.post("/auth/refresh").finally(() => { refreshing = null; });
  await refreshing;
  return api(cfg);
});

export function formatApiError(e) {
  const detail = e?.response?.data?.detail;
  if (detail == null) return e?.message || "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((d) => (d && typeof d.msg === "string" ? d.msg : JSON.stringify(d))).join(" ");
  if (typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const money = (n) =>
  `$${Number(n || 0).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

export const money0 = (n) => `$${Math.round(Number(n || 0)).toLocaleString("en-US")}`;

export const fmtDate = (s) => (s ? new Date(s).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" }) : "—");

export const pad = (n) => (n == null ? "—" : `#${String(n).padStart(3, "0")}`);

export const startCheckout = async (body) => {
  const r = await api.post("/payments/checkout", { ...body, origin_url: window.location.origin });
  window.location.assign(r.data.checkout_url);
};
